import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Korean from "./views/kor";
import Japanese from "./views/jpn";
import Spanish from "./views/esp";
import Home from "./views/home";
import System from "./views/jpn/system";
import KoreanSystem from "./views/kor/system";

const systems = ["hiragana", "katakana", "kanji"];
const koreanSystems = ["hangul"];

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/spanish" component={Spanish} />
        <Route exact path="/japanese" component={Japanese} />
        <Route exact path="/korean" component={Korean} />
        {systems.map((system, i) => (
          <Route path={`/japanese/${system}`}>
            <System type={system} />
          </Route>
        ))}
        {koreanSystems.map((system, i) => (
          <Route path={`/korean/${system}`}>
            <KoreanSystem type={system} />
          </Route>
        ))}
        <Route path="*" component={Home} />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
